module.exports = "<div id=anchor-list><div group=resume class=grp-label>Resume</div><div group=resume class=group><anchor href=#profile>Profile</anchor><anchor href=#skills>Skills</anchor><anchor href=#experiences>Experiences</anchor><anchor href=#education>Education</anchor><anchor href=#hire-me>Hire Me!</anchor></div><div group=portfolio class=grp-label>Portfolio</div><div group=portfolio class=group><anchor href=#online-demo>Online Demo</anchor><anchor href=#screenshots>Screenshots</anchor></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnchorList.vue
 ** module id = 215
 ** module chunks = 0
 **/